import Badge from "./badge.inline.svg";
import Shine from "./shine.inline.svg";
import Graph from "./graph.inline.svg";
import Rocket from "./rocket.inline.svg";
import Cursor from "./cursor.inline.svg";
import Mobile from "./mobile.inline.svg";
import Product from "./product.inline.svg";
import Outsourcing from "./outsourcing.inline.svg";
import Upload from "./upload.inline.svg";
import Remove from "./remove.inline.svg";
import Chart from "./chart.inline.svg";
import Astronaut from "./astronaut.inline.svg";
import Clock from "./clock.inline.svg";
import Planet from "./planet.inline.svg";
import Web from "./web.inline.svg";
import Gear from "./gear.inline.svg";

export default {
  Badge,
  Shine,
  Graph,
  Rocket,
  Cursor,
  Mobile,
  Product,
  Outsourcing,
  Upload,
  Remove,
  Chart,
  Astronaut,
  Clock,
  Planet,
  Web,
  Gear,
};
